import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { stageFiles } from '@/services/git/api';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

interface StageFilesInput {
  files: Array<{ path: string; metadata_branch_id?: string }>;
}

export function useStageFiles(): UseMutationResult<{ staged_count: number }, Error, StageFilesInput> {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? '');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ files }: StageFilesInput) => stageFiles(orgId, files),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['stagedFiles', orgId] }),
  });
}
